import { authStore } from '@/store/store'
import QueryString from 'qs';

export default [
  {
    path: "/dashboard",
    name: "dashboard",
    meta: { authRequired: true},
    component: () => import("./views/dashboard/insight")
  },
  //Authentication Routes
  {
    path: "/",
    name: "login",
    component: () => import("./views/auth/login"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        const authUser = authStore().decryptAuth.isLoggedIn
        if (authUser) {
          const path = `/dashboard${(routeTo.query) ? '?'+QueryString.stringify(routeTo.query) : ''}`
          next(path)
        } else {
          next();
        }
      },
    },
    params: true,
  },
  /*
  {
    path: "/register",
    name: "register",
    component: () => import("./views/auth/register"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        const authUser = authStore().decryptAuth.isLoggedIn
        if (authUser) {
          next({ name: "dashboard" });
        } else {
          next();
        }
      },
    },
  },*/
  {
    path: "/confirm",
    name: "confirm",
    component: () => import("./views/auth/confirm-registration"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        const authUser = authStore().decryptAuth.isLoggedIn
        if (authUser) {
          next({ name: "dashboard" });
        } else {
          next();
        }
      },
    },
  },
  {
    path: "/forgot-password",
    name: "forgot-password",
    component: () => import("./views/auth/forgot-password"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        const authUser = authStore().decryptAuth.isLoggedIn
        if (authUser) {
          next({ name: "dashboard" });
        } else {
          next();
        }
      },
    },
  },
  {
    path: "/reset-password/:id",
    name: "reset-password",
    component: () => import("./views/auth/reset-password"),
  },
  {
    path: "/logout",
    name: "logout",
    component: () => import("./views/auth/logout"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        authStore().logOut()
        const authRequiredOnPreviousRoute = routeFrom.matched.some((route) =>
          route.push("/")
        );
        // Navigate back to previous page, or home as a fallback
        next(
          authRequiredOnPreviousRoute ? { name: "login" } : { ...routeFrom }
        );
      },
    },
  },
  //On-Boarding Routes
  {
    path: "/on-boarding/persona",
    name: "onboarding-personal",
    meta: { authRequired: true},
    component: () => import("./views/on-boarding/persona")
  },
  {
    path: "/on-boarding/bank-verification/choose-currency",
    name: "onboarding-choose-currency",
    meta: { authRequired: true},
    component: () => import("./views/on-boarding/choose-currency")
  },
  {
    path: "/on-boarding/bank-verification/CAD",
    name: "onboarding-canadian-bank-verification",
    meta: { authRequired: true},
    component: () => import("./views/on-boarding/canadian-bank-verification")
  },
  {
    path: "/on-boarding/bank-verification/NGN",
    name: "onboarding-naira-bank-verification",
    meta: { authRequired: true},
    component: () => import("./views/on-boarding/naira-bank-verification")
  },

  //EXCHANGES...AND... TRANSACTIONS
  //instant-swap
  {
    path: "/instant-swap",
    name: "instant-swap",
    meta: { authRequired: true},
    component: () => import("./views/exchange/instant-swap")
  },

  {
    path: "/instant-swap/:id",
    name: "instant-swap-with-id",
    meta: { authRequired: true},
    component: () => import("./views/exchange/instant-swap")
  },



  {
    path: "/exchange",
    name: "exchange-history",
    meta: { authRequired: true},
    component: () => import("./views/exchange/history")
  },

  {
    path: "/exchange/:id",
    name: "exchange-history-details",
    meta: { authRequired: true},
    component: () => import("./views/exchange/details")
  },


  {
    path: "/wallet",
    name: "wallet",
    meta: { authRequired: true},
    component: () => import("./views/wallet/preview")
  },

  {
    path: "/wallet/:id",
    name: "wallet-details",
    meta: { authRequired: true},
    component: () => import("./views/wallet/details")
  },

  {
    path: "/wallet/account/:id",
    name: "wallet-account-details",
    meta: { authRequired: true},
    component: () => import("./views/wallet/account-details")
  },

  {
    path: "/wallet/logs",
    name: "wallet-logs",
    meta: { authRequired: true},
    component: () => import("./views/wallet/logs")
  },

  {
    path: "/profile",
    name: "profile",
    meta: { authRequired: true},
    component: () => import("./views/profile/overview")
  },
  
  /*
    {
      path: "/profile/mfa",
      name: "profile-mfa",
      meta: { authRequired: true},
      component: () => import("./views/profile/mfa")
    },
    
    {
      path: "/profile/mfa-verification",
      name: "profile-mfa-verification",
      meta: { authRequired: true},
      component: () => import("./views/profile/mfa-verification")
    },
  */

  {
    path: "/transactions",
    name: "transactions",
    meta: { authRequired: true},
    component: () => import("./views/wallet/transactions")
  },

  {
    path: "/disbursement",
    name: "disbursement",
    meta: { authRequired: true},
    component: () => import("./views/wallet/disbursement")
  },

  // ## START OF TELEGRAM

  {
    path: "/telegram/connect",
    name: "telegram-connect",
    component: () => import("./views/telegram/connect"),
  },

  {
    path: "/telegram/sell",
    name: "telegram-sell",
    component: () => import("./views/telegram/sell"),
  },

  {
    path: "/telegram/buy",
    name: "telegram-buy",
    component: () => import("./views/telegram/buy"),
  },

  {
    path: "/telegram/fund",
    name: "telegram-fund",
    component: () => import("./views/telegram/fund"),
  },

  {
    path: "/telegram/withdraw",
    name: "telegram-withdraw",
    component: () => import("./views/telegram/withdraw"),
  },


  //  # BOT AGENT


  // ## END OF TELEGRAM


  // ## START OF ADMIN PAGE

  {
    path: "/bot-agent/config",
    name: "bot-agent-config",
    meta: { authRequired: true},
    component: () => import("./views/admin/bot-activity/config")
  },

  {
    path: "/bot-agent/engagement",
    name: "bot-agent-engagement",
    meta: { authRequired: true},
    component: () => import("./views/admin/bot-activity/engagement")
  },

  {
    path: "/bot-agent/engagement/:id",
    name: "bot-agent-engagement-with-id",
    meta: { authRequired: true},
    component: () => import("./views/admin/bot-activity/engagement")
  },

  {
    path: "/admin/user",
    name: "admin-user",
    meta: { authRequired: true},
    component: () => import("./views/admin/user/overview")
  },

  {
    path: "/admin/user/:id",
    name: "admin-user-review",
    meta: { authRequired: true},
    component: () => import("./views/admin/user/modify")
  },

  {
    // FINTRAC alert viewer: the Slack "Open Report" deep-link target.
    // ADMIN-only; the API (isStrictAdmin) is the real gate, this is UX.
    path: "/fintrac-reporting/:alertId?",
    name: "fintrac-alert",
    meta: { authRequired: true },
    component: () => import("./views/admin/fintrac/alert")
  },

  {
    path: "/admin/exchanges",
    name: "admin-exchanges",
    meta: { authRequired: true},
    component: () => import("./views/admin/exchange/list")
  },

  {
    path: "/admin/exchanges/analytics",
    name: "admin-exchanges-analytics",
    meta: { authRequired: true},
    component: () => import("./views/admin/exchange/analytics")
  },

  {
    path: "/admin/exchange/:id",
    name: "admin-exchange-review",
    meta: { authRequired: true},
    component: () => import("./views/admin/exchange/detail")
  },

  {
    path: "/admin/bot-agent",
    name: "admin-bot-agent",
    meta: { authRequired: true},
    component: () => import("./views/admin/user/bot-agent")
  },

  {
    path: "/admin/bot-agent/:id",
    name: "admin-bot-agent-edit",
    meta: { authRequired: true},
    component: () => import("./views/admin/user/bot-agent")
  },



  /*{
    path: "/admin/user/kyc",
    name: "admin-user-kyc",
    meta: { authRequired: true},
    component: () => import("./views/admin/user/kyc")
  },*/

  {
    path: "/admin/user/kyc/:id",
    name: "admin-user-kyc-review",
    meta: { authRequired: true},
    component: () => import("./views/admin/user/kyc-review")
  },

  {
    path: "/admin/wallet",
    name: "admin-wallet",
    meta: { authRequired: true},
    component: () => import("./views/admin/wallet/overview")
  },

  {
    path: "/admin/wallet/:id",
    name: "admin-wallet-id",
    meta: { authRequired: true},
    component: () => import("./views/admin/wallet/overview")
  },

  {
    path: "/admin/payment",
    name: "admin-wallet-payment",
    meta: { authRequired: true},
    component: () => import("./views/admin/wallet/payment")
  },

  {
    path: "/admin/payment/:id",
    name: "admin-wallet-payment-id",
    meta: { authRequired: true},
    component: () => import("./views/admin/wallet/payment")
  },

  {
    path: "/admin/disbursement",
    name: "admin-wallet-disbursement",
    meta: { authRequired: true},
    component: () => import("./views/admin/wallet/disbursement")
  },

  {
    path: "/admin/disbursement/:id",
    name: "admin-wallet-disbursement-id",
    meta: { authRequired: true},
    component: () => import("./views/admin/wallet/disbursement")
  },

  {
    path: "/admin/rate",
    name: "admin-rate",
    meta: { authRequired: true},
    component: () => import("./views/admin/rate/overview")
  },

  {
    path: "/admin/rate/add",
    name: "admin-add-rate",
    meta: { authRequired: true},
    component: () => import("./views/admin/rate/add")
  },

  {
    path: "/admin/tools/trade-bot",
    name: "admin-tools-trade-bot",
    meta: { authRequired: true},
    component: () => import("./views/admin/tools/trade-bot")
  },

  {
    path: "/admin/broadcast",
    name: "admin-broadcast",
    meta: { authRequired: true},
    component: () => import("./views/admin/broadcast")
  },

  // ### END OF ADMIN ROUTES


  // ### RCAD — settlement reserve
  {
    path: "/rcad/reserve",
    name: "rcad-reserve",
    meta: { authRequired: true},
    component: () => import("./views/rcad/reserve")
  },

  // ### END OF RCAD ROUTES


  // ### SOME MERCHANT ROUTES
  {
    path: "/merchant/invite",
    name: "merchant-customer-invite",
    meta: { authRequired: true},
    component: () => import("./views/merchant/invite")
  },

  {
    path: "/merchant/customers",
    name: "merchant-customers",
    meta: { authRequired: true},
    component: () => import("./views/merchant/customers")
  },

  {
    path: "/merchant/transactions",
    name: "merchant-customers-transactions",
    meta: { authRequired: true},
    component: () => import("./views/merchant/transactions")
  },


  // ### END OF MERCHANT ROUTES




  // STATIC PAGES WITHOUT AUTHENTICATION
  {
    path: "/about",
    name: "about",
    component: () => import("./views/static/about"),
  },

  {
    path: "/products",
    name: "products",
    component: () => import("./views/static/product"),
  },

  {
    path: "/privacy-policy",
    name: "privacy-policy",
    component: () => import("./views/static/privacy-policy"),
  },

  {
    path: "/terms-and-conditions",
    name: "terms-and-conditions",
    component: () => import("./views/static/terms-and-conditions"),
  },

  {
    path: "/contact-and-support",
    name: "contact-and-suppport",
    component: () => import("./views/static/contact-and-support"),
  },

  {
    path: "/faqs",
    name: "faq",
    component: () => import("./views/static/faq"),
  },

  {
    path: "/apple-app-site-association",
    name: "apple-app-site-association",
    component: () => import("./views/static/apple-site"),
  },
  
  

];